import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

interface BookingStatusDisplayProps {
  isImported: boolean;
  isRejected: boolean;
  hasChanges: boolean;
}

const BookingStatusDisplay: React.FC<BookingStatusDisplayProps> = ({
  isImported,
  isRejected,
  hasChanges,
}) => {
  if (isImported) {
    return (
      <div className='p-4 rounded-lg border border-green-200 bg-green-50'>
        <div className='flex items-center gap-3 text-green-700'>
          <CheckCircleIcon className='w-6 h-6 flex-shrink-0' />
          <div>
            <p className='font-medium text-sm'>Booking Imported</p>
            <p className='text-xs text-green-600'>
              This booking data has been successfully imported
              {hasChanges && ' with changes'}.
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (isRejected) {
    return (
      <div className='p-4 rounded-lg border border-red-200 bg-red-50'>
        <div className='flex items-center gap-3 text-red-700'>
          <XCircleIcon className='w-6 h-6 flex-shrink-0' />
          <div>
            <p className='font-medium text-sm'>Booking Rejected</p>
            <p className='text-xs text-red-600'>
              This booking data has been rejected. To try again, add the same
              file to the import to start over.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default BookingStatusDisplay;
